module.exports = __webpack_public_path__ + "img/logo_aisea_line.5c8263de.svg";